import {SiteEntity} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";

export type BaseSiteMultiSelectProps = Omit<
    BaseEntityMultiSelectProps<SiteEntity>,
    'nameMapper'
>;

export const BaseSiteMultiSelect = (props: BaseSiteMultiSelectProps) => {
    const nameMapper = useCallback((e: SiteEntity) => {
        return e.name;
    }, []);

    return <BaseEntityMultiSelect nameMapper={nameMapper} {...props} />;
};
